import { useTranslation } from 'react-i18next';
import { Plus, X } from 'lucide-react';
import { Input } from './ui.js';

/** Primary value remains first; adding/editing another contact never discards it. */
export function ContactValuesField({ label, values, onChange, type = 'text' }: { label: string; values: string[]; onChange: (values: string[]) => void; type?: 'text' | 'email' | 'tel' }) {
  const { t } = useTranslation();
  const rows = values.length ? values : [''];
  return <fieldset className="min-w-0 space-y-1">
    <legend className="text-xs font-semibold text-muted-foreground">{label}</legend>
    {rows.map((value, index) => <div key={index} className="flex min-w-0 items-center gap-1">
      <Input aria-label={`${label} ${index + 1}`} type={type} dir={type === 'text' ? undefined : 'ltr'} value={value} onChange={(event) => onChange(rows.map((row, at) => at === index ? event.target.value : row))} />
      {index > 0 && <button type="button" aria-label={t('common.delete')} onClick={() => onChange(rows.filter((_, at) => at !== index))}><X className="h-4 w-4" /></button>}
    </div>)}
    {rows.length < 20 && <button type="button" className="inline-flex items-center gap-1 text-xs text-primary" onClick={() => onChange([...rows, ''])}><Plus className="h-3 w-3" />{t('customer.addContactValue')}</button>}
  </fieldset>;
}
